import AsyncScriptService from 'services/loader-handler-services/async-script-service';
import utils from 'lib/utils';

export default class AsyncBlockService {
  static load(names, requireables) {
    if (!Array.isArray(names) && names) {
      names = [names];
    }
    return AsyncScriptService.load(
      names.map(name => {
        return {
          http: utils.coursePath(`javascripts/blocks/${name}.js`),
          require: `views/block/${name}/${name}-view`,
        };
      }),
      requireables
    );
  }
}
